module.exports = __webpack_public_path__ + "media/images/icons/home_line-118115d2192985c77188ba2897f34139.svg";